// Diferir la inicialización para no bloquear el LCP
(function() {
  'use strict';
  
  function initCarousel(carousel) {
    const track = carousel.querySelector('[data-track]');
    const cards = track?.children;
    const prevBtn = carousel.querySelector('.collection-carousel__btn--prev');
    const nextBtn = carousel.querySelector('.collection-carousel__btn--next');
    const paginationContainer = carousel.querySelector('[data-pagination]');

    if (!track || !cards || cards.length === 0) return;

    const desktopVisible = +carousel.dataset.desktopVisible || 6;
    const tabletVisible = +carousel.dataset.tabletVisible || 4;
    const mobileVisible = +carousel.dataset.mobileVisible || 2;
    const gap = +carousel.dataset.gap || 20;

    carousel.style.cssText += `--desktop-visible:${desktopVisible};--tablet-visible:${tabletVisible};--mobile-visible:${mobileVisible};--gap:${gap}px`;

    let currentPage = 0;
    let currentVisible = getVisibleCards();
    let totalPages = 0;
    let dots = [];
    let cardWidth = 0;
    let wrapperWidth = 0;
    
    // Variables para swipe/drag
    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = 0;
    let velocity = 0;
    let lastTime = 0;
    let lastX = 0;
    let isScrolling = false;

    function getVisibleCards() {
      const w = window.innerWidth;
      if (w <= 480) return 1;
      if (w <= 768) return mobileVisible;
      if (w <= 1024) return tabletVisible;
      return desktopVisible;
    }

    function calculateTotalPages() {
      if (!cards.length) return 0;
      
      currentVisible = Math.min(currentVisible, cards.length);
      totalPages = Math.floor(cards.length / currentVisible);
      
      if (totalPages === 0 && cards.length > 0) {
        totalPages = 1;
      }
      
      return totalPages;
    }

    function buildPagination() {
      const fragment = document.createDocumentFragment();
      dots = [];
      
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('div');
        dot.className = 'collection-carousel__pagination-dot' + (i === 0 ? ' active' : '');
        dot.dataset.page = i;
        dots.push(dot);
        fragment.appendChild(dot);
      }
      
      paginationContainer.textContent = '';
      paginationContainer.appendChild(fragment);
    }

    function canGoNext() {
      const nextPageStartIndex = (currentPage + 1) * currentVisible;
      return nextPageStartIndex + currentVisible <= cards.length;
    }

    function calculateMaxTranslate() {
      // Calcular ancho total del carrusel
      const totalTrackWidth = cardWidth * cards.length + gap * (cards.length - 1);
      
      // Calcular desplazamiento máximo (última tarjeta alineada al borde derecho)
      return -(totalTrackWidth - wrapperWidth);
    }

    function goToPage(page) {
      if (page < 0) page = 0;
      if (page >= totalPages) page = totalPages - 1;
      if (page === currentPage) return;
      
      currentPage = page;

      // Recalcular cardWidth si es necesario
      if (!cardWidth && cards[0]) {
        cardWidth = cards[0].offsetWidth;
        wrapperWidth = track.parentElement.offsetWidth;
      }

      // ====== CORRECCIÓN PARA EL ESPACIO EN BLANCO ======
      let translateX;
      
      if (page === totalPages - 1) {
        // Alinear última tarjeta al borde derecho
        translateX = calculateMaxTranslate();
      } else {
        // Para páginas intermedias, usar cálculo normal
        const groupWidth = cardWidth * currentVisible + gap * (currentVisible - 1);
        translateX = -page * groupWidth;
      }
      // ==================================================

      track.style.transform = `translateX(${translateX}px)`;

      // Actualizar estado
      const isFirst = currentPage === 0;
      const isLast = !canGoNext();

      for (let i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('active', i === currentPage);
      }

      prevBtn.disabled = isFirst;
      nextBtn.disabled = isLast;
      prevBtn.style.opacity = isFirst ? '0.4' : '1';
      nextBtn.style.opacity = isLast ? '0.4' : '1';
    }

    function updateCarousel() {
      const previousPage = currentPage;
      
      currentVisible = getVisibleCards();
      totalPages = calculateTotalPages();
      cardWidth = 0;
      
      if (previousPage >= totalPages) {
        currentPage = Math.max(0, totalPages - 1);
      }
      
      buildPagination();
      goToPage(currentPage);
    }

    // === SWIPE/DRAG IMPLEMENTATION ===
    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    function getScrollY(event) {
      return event.type.includes('mouse') ? 0 : event.touches[0].clientY;
    }

    function animation() {
      track.style.transform = `translateX(${currentTranslate}px)`;
      animationID = requestAnimationFrame(animation);
    }

    function setPositionByIndex() {
      if (!cardWidth && cards[0]) {
        cardWidth = cards[0].offsetWidth;
        wrapperWidth = track.parentElement.offsetWidth;
      }
      
      let position;
      if (currentPage === totalPages - 1) {
        position = calculateMaxTranslate();
      } else {
        const groupWidth = cardWidth * currentVisible + gap * (currentVisible - 1);
        position = -currentPage * groupWidth;
      }
      
      currentTranslate = position;
      prevTranslate = currentTranslate;
      
      track.style.transform = `translateX(${currentTranslate}px)`;
    }

    // Touch events para swipe
    track.addEventListener('touchstart', touchStart);
    track.addEventListener('touchend', touchEnd);
    track.addEventListener('touchmove', touchMove);
    track.addEventListener('touchcancel', touchEnd);

    function touchStart(event) {
      if (event.touches.length > 1) return;
      
      isDragging = true;
      startPos = getPositionX(event);
      lastX = startPos;
      lastTime = Date.now();
      isScrolling = false;
      
      // Obtener dimensiones
      if (!cardWidth && cards[0]) {
        cardWidth = cards[0].offsetWidth;
        wrapperWidth = track.parentElement.offsetWidth;
      }
      
      // Iniciar animación
      cancelAnimationFrame(animationID);
      animation();
      
      // Guardar posición actual
      const style = window.getComputedStyle(track);
      const matrix = new DOMMatrix(style.transform);
      prevTranslate = matrix.m41;
      currentTranslate = prevTranslate;
      
      // Prevenir scroll de página
      track.style.touchAction = 'none';
    }

    function touchMove(event) {
      if (!isDragging) return;
      
      // Detectar si es scroll vertical
      if (!isScrolling) {
        const currentY = event.touches[0].clientY;
        const startY = event.touches[0].clientY - (currentY - event.touches[0].clientY);
        const yDiff = Math.abs(currentY - startY);
        const xDiff = Math.abs(getPositionX(event) - startPos);
        
        if (yDiff > xDiff) {
          isScrolling = true;
          isDragging = false;
          cancelAnimationFrame(animationID);
          return;
        }
      }
      
      // Calcular nueva posición
      const currentPosition = getPositionX(event);
      const diff = currentPosition - startPos;
      currentTranslate = prevTranslate + diff;
      
      // ====== CLAMP PARA PREVENIR ESPACIO EN BLANCO ======
      const maxTranslate = calculateMaxTranslate();
      currentTranslate = Math.max(maxTranslate, Math.min(currentTranslate, 0));
      // ==================================================
      
      // Calcular velocidad para momentum
      const now = Date.now();
      const timeDiff = now - lastTime;
      if (timeDiff > 0) {
        velocity = (currentPosition - lastX) / timeDiff;
      }
      lastX = currentPosition;
      lastTime = now;
      
      event.preventDefault();
    }

    function touchEnd() {
      if (!isDragging) return;
      
      isDragging = false;
      cancelAnimationFrame(animationID);
      
      // Determinar si avanzar o retroceder
      const movedBy = currentTranslate - prevTranslate;
      
      // ====== CORRECCIÓN PARA EL ESPACIO EN BLANCO DURANTE SWIPE ======
      const maxTranslate = calculateMaxTranslate();
      const isAtEnd = Math.abs(currentTranslate - maxTranslate) < 5;
      
      if (movedBy < -50 && (canGoNext() || isAtEnd)) {
        currentPage++;
        goToPage(currentPage);
      } else if (movedBy > 50 && currentPage > 0) {
        currentPage--;
        goToPage(currentPage);
      } else {
        // Volver a la posición original con suavidad
        setPositionByIndex();
      }
      // ============================================================
      
      // Restaurar touchAction
      setTimeout(() => {
        track.style.touchAction = '';
      }, 100);
    }

    // Event delegation para paginación
    paginationContainer.addEventListener('click', function(e) {
      const page = e.target.dataset.page;
      if (page !== undefined) goToPage(+page);
    });

    prevBtn.addEventListener('click', () => {
      if (currentPage > 0) {
        goToPage(currentPage - 1);
      }
    });
    
    nextBtn.addEventListener('click', () => {
      if (canGoNext()) {
        goToPage(currentPage + 1);
      }
    });

    // Inicializar
    updateCarousel();

    // Resize con debounce
    let resizeId;
    window.addEventListener('resize', function() {
      clearTimeout(resizeId);
      resizeId = setTimeout(updateCarousel, 150);
    }, { passive: true });
  }

  function init() {
    const carousels = document.querySelectorAll('.collection-carousel-section');
    for (let i = 0; i < carousels.length; i++) {
      initCarousel(carousels[i]);
    }
  }

  // Ejecutar después del LCP
  if ('requestIdleCallback' in window) {
    requestIdleCallback(init, { timeout: 2000 });
  } else {
    requestAnimationFrame(function() {
      requestAnimationFrame(init);
    });
  }
})();